export default __webpack_public_path__ + "static/media/(28).67d14e95.jpg";